export const Urls = {
  FEEDBACK_FAQ: 'kwaiying://krn?bundleId=KyFeedback&componentName=faq',
};
